<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.2 17.21">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g id="Icon-Photos">
                    <path 
                    id="Path_436" 
                    data-name="Path 436" 
                    class="cls-1" 
                    :fill="this.$vuetify.theme.dark ? '#CECECE' : '#231815'"
                    d="M3.41,1.74A8.6,8.6,0,0,0,0,8.27L7.33,4.05ZM9.63,13.3l-.05,0h0ZM11.87.64A8.62,8.62,0,0,0,4.66,1L11.87,5.2Zm1.31,9.12,3.95-2.3a8.6,8.6,0,0,0-3.95-6.14V6h0ZM.07,9.75A8.61,8.61,0,0,0,4,15.9L4,7.48Zm9.54,3.6,3.72,2.45A8.61,8.61,0,0,0,17.2,8.93ZM5.33,16.57A8.63,8.63,0,0,0,12,16.51l-6.7-4.43Z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'MediaIcon'
}
</script>

<style scoped>
    svg {
        width:17.2px;
        height: 17.21px;
    }
</style>